
import { createNamespacedHelpers } from '@/common/vuex-composition-hooks';
import { defineComponent, onMounted } from 'vue-demi';
import DashboardRealizedBudget from './DashboardRealizedBudget.vue';
import DashboardMonthTotals from './DashboardMonthTotals.vue';

import { IDashboardBrandManagementState, IBrandManagerActions } from '../types';
const { useState, useActions } = createNamespacedHelpers<
  IDashboardBrandManagementState,
  null,
  IBrandManagerActions
>('dashboardBrandManagement');

export default defineComponent({
  components: {
    DashboardRealizedBudget,
    DashboardMonthTotals,
  },

  data() {
    return {
      dados: '',
    };
  },

  setup() {
    const {
      fetchRealizedBudgetWls,
      fetchRealizedBudgetDtc,
      fetchRealizedBudgetExport,
      fetchRealizedBudgetEcomm,
      fetchMonthTotalsWls,
      fetchMonthTotalsDtc,
      fetchMonthTotalsExport,
      fetchMonthTotalsEcomm,
    } = useActions([
      'fetchRealizedBudgetWls',
      'fetchRealizedBudgetDtc',
      'fetchRealizedBudgetExport',
      'fetchRealizedBudgetEcomm',
      'fetchMonthTotalsWls',
      'fetchMonthTotalsDtc',
      'fetchMonthTotalsExport',
      'fetchMonthTotalsEcomm',
    ]);
    const {
      realizedBudgetWholesale,
      realizedBudgetDtc,
      realizedBudgetExport,
      realizedBudgetEcomm,
      loadingRealizedBudgetWholesale,
      loadingRealizedBudgetDtc,
      loadingRealizedBudgetExport,
      loadingRealizedBudgetEcomm,
      monthTotalsDtc,
      monthTotalsWholesale,
      monthTotalsExport,
      monthTotalsEcomm,
      loadingMonthTotalsWholesale,
      loadingMonthTotalsDtc,
      loadingMonthTotalsExport,
      loadingMonthTotalsEcomm,
      accessWholesale,
      accessDtc,
      accessExport,
      accessEcomm,
    } = useState([
      'realizedBudgetWholesale',
      'realizedBudgetDtc',
      'realizedBudgetExport',
      'realizedBudgetEcomm',
      'loadingRealizedBudgetWholesale',
      'loadingRealizedBudgetDtc',
      'loadingRealizedBudgetExport',
      'loadingRealizedBudgetEcomm',
      'monthTotalsDtc',
      'monthTotalsWholesale',
      'monthTotalsExport',
      'monthTotalsEcomm',
      'loadingMonthTotalsWholesale',
      'loadingMonthTotalsDtc',
      'loadingMonthTotalsExport',
      'loadingMonthTotalsEcomm',
      'accessWholesale',
      'accessDtc',
      'accessExport',
      'accessEcomm',
    ]);

    onMounted(() => {
      fetchRealizedBudgetWls();
    });

    onMounted(() => {
      fetchRealizedBudgetDtc();
    });

    onMounted(() => {
      fetchRealizedBudgetExport();
    });

    onMounted(() => {
      fetchRealizedBudgetEcomm();
    });

    onMounted(() => {
      fetchMonthTotalsWls();
    });

    onMounted(() => {
      fetchMonthTotalsDtc();
    });

    onMounted(() => {
      fetchMonthTotalsExport();
    });

    onMounted(() => {
      fetchMonthTotalsEcomm();
    });

    return {
      realizedBudgetWholesale,
      realizedBudgetDtc,
      realizedBudgetExport,
      realizedBudgetEcomm,
      loadingRealizedBudgetWholesale,
      loadingRealizedBudgetDtc,
      loadingRealizedBudgetExport,
      loadingRealizedBudgetEcomm,
      monthTotalsDtc,
      monthTotalsWholesale,
      monthTotalsExport,
      monthTotalsEcomm,
      loadingMonthTotalsWholesale,
      loadingMonthTotalsDtc,
      loadingMonthTotalsExport,
      loadingMonthTotalsEcomm,
      accessWholesale,
      accessDtc,
      accessExport,
      accessEcomm,
    };
  },
});
